import { Component, OnInit } from '@angular/core';
import { MessageService } from '../shared/message.service';
import { MessageType } from '../shared/messageType';
import { PlatformIdmService } from '@platform-idm/sdk-angular';

@Component({
    selector: 're-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(
    private messages: MessageService,
    private authService: PlatformIdmService
  ) { }

  ngOnInit() {
    (this.authService.authentication as any)?.stopTimers();

    this.messages.send(MessageType.Logout);
  }

}
